/*@flow*/
import { getTypeName, fail, type TypeT } from 'lib/t';
import { SOURCE } from '../util';
import {
  Textbox,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Select,
  Datetime,
  Struct,
  List,
} from './';

export default function factory(
  type: TypeT<*>,
  options: { factory?: React$ComponentType<*>, type?: string }
): React$ComponentType<*> {
  if (options.factory) return options.factory;
  if (type.getTcombFormFactory) return type.getTcombFormFactory(options);

  const name = getTypeName(type);
  switch (type.meta.kind) {
    case 'irreducible':
      if (type.meta.name === 'Boolean') {
        return Checkbox;
      } else if (type.meta.name === 'Date') {
        return Datetime;
      }
      return Textbox;
    case 'struct':
    case 'interface':
      return Struct;
    case 'list':
      return List;
    case 'enums':
      if (options.type === 'CheckboxGroup') {
        return CheckboxGroup;
      } else if (options.type === 'RadioGroup') {
        return RadioGroup;
      }
      return Select;
    case 'maybe':
    case 'subtype':
      return factory(type.meta.type, options);
    default:
      return fail(
        `[${SOURCE}] unsupported kind ${type.meta.kind} for type ${name}`
      );
  }
}
